<mat-dialog-content>
    <div (closePopupEvent)="cancel()" class="resource-import">
        <div class="import_header">
            <h3>Import Resources</h3>
            <button mat-icon-button (click)="cancel()" [disabled]="loading"><mat-icon>close</mat-icon></button>
        </div>
        <div class="import_content">
            <div class="dropfile_cotainer">
                <div class="dropzone" appDragDropFile (files)="import($event)" *ngIf="!loading">
                    <mat-icon>upload_file</mat-icon>
                </div>
                <div class="dropzone import_info" *ngIf="loading">
                    <div class="label_importing">Importing</div>
                    <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
                    <mat-spinner mode="indeterminate"></mat-spinner>
                </div>
                <div *ngIf="loading">Filename: {{filename}}</div>
            </div>
            <div class="import_instructions">
                <h3>Drag & Drop a file to start importing resources</h3>
                <span class="import_sample-link">
                    <a (click)="downloadSampleCSV()">click here</a> to download sample csv
                </span>
            </div>
            <button mat-raised-button color="primary" (click)="importData.click()" [disabled]="loading">
                Browse
            </button>
            <input #importData type="file" style="display: none" (change)="import($event)" accept=".csv" />
        </div>
        <div></div>
    </div>
</mat-dialog-content>